exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".approval-list-container[data-v-e1cb7416]{padding:1rem}.cell-content div[data-v-e1cb7416]{margin-bottom:2px}.extra-small[data-v-e1cb7416]{font-size:.7rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-e1cb7416","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/component/payment/SlineApprovalList.vue
// module id = 1822
// module chunks = 0